import { render, staticRenderFns } from "./page-contact-three.vue?vue&type=template&id=01fc7af1&"
import script from "./page-contact-three.vue?vue&type=script&lang=js&"
export * from "./page-contact-three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports